/**
 * Mensagem padrão de boot — overlay minimalista (foto + texto central + engrenagens).
 */

import { hubProductionGearsSvgMarkup } from './hub-production-loader.js';

export const PH_APP_BOOT_MESSAGE = 'SysFactory · preparando seu workspace…';

const LOADING_DOTS_HTML =
  '<span class="ph-loading-dots" aria-hidden="true"><span>.</span><span>.</span><span>.</span></span>';

/**
 * @param {string} [message]
 * @param {{ withDots?: boolean; captionId?: string }} [opts]
 */
export function appBootLabelHtml(message = PH_APP_BOOT_MESSAGE, opts = {}) {
  const withDots = opts.withDots !== false;
  const idAttr = opts.captionId ? ` id="${opts.captionId}"` : '';
  const text = withDots ? `${message}${LOADING_DOTS_HTML}` : message;
  return `<p class="ph-app-boot-label"${idAttr}>${text}</p>`;
}

/** Engrenagens industriais (tema produção). */
export function appBootGearsHtml() {
  return `<span class="ph-app-boot-gears ph-hub-prod-gears-wrap" aria-hidden="true">${hubProductionGearsSvgMarkup({ compact: true })}</span>`;
}

/** @param {ParentNode | null | undefined} root */
export function hasAppBootGearsVisual(root) {
  return !!root?.querySelector?.('.ph-app-boot-gears');
}

/** Overlay incompleto (engrenagens soltas, sem coluna central ou sem barra de %). */
export function needsAppBootOverlayUpgrade(root) {
  if (!root) return false;
  if (!root.querySelector('.ph-app-boot-overlay-inner')) return true;
  if (!root.querySelector('.ph-app-boot-progress')) return true;
  return !hasAppBootGearsVisual(root);
}

export function appBootProgressBarMarkup() {
  return `<div class="ph-app-boot-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" aria-label="Progresso do carregamento">
    <div class="ph-app-boot-progress-track" aria-hidden="true">
      <div class="ph-app-boot-progress-bar"><span style="width:0%"></span></div>
    </div>
    <p class="ph-app-boot-progress-pct">0%</p>
  </div>`;
}

/** Três pontos cyan — alternativa leve (`spinner: true` no overlay). */
export function appBootSpinnerHtml() {
  return `<span class="ph-app-boot-spinner" aria-hidden="true"><span></span><span></span><span></span></span>`;
}

/** Markup interno do overlay (engrenagens + legenda; pontos só com `spinner: true`). */
export function appBootOverlayInnerHtml(message = PH_APP_BOOT_MESSAGE, opts = {}) {
  const visual = opts.spinner ? appBootSpinnerHtml() : appBootGearsHtml();
  const progress =
    opts.withProgress === false ? '' : appBootProgressBarMarkup();
  return `<div class="ph-app-boot-overlay-inner">${visual}${appBootLabelHtml(message, opts)}${progress}</div>`;
}

/**
 * Overlay de boot operacional (viewer, painel…) — incluir no HTML para first paint sem piscar.
 * @param {string} [message]
 */
export function pageBootOverlayElementHtml(message = PH_APP_BOOT_MESSAGE) {
  return `<div id="phPageBootOverlay" class="ph-page-boot-overlay ph-app-boot-overlay" role="status" aria-live="polite" aria-busy="true" aria-label="Carregando">${appBootOverlayInnerHtml(message, { withDots: false, withProgress: true })}</div>`;
}

/** Gate de módulo (peças, estoque…) — mesmo markup vertical do boot global. */
export function appBootGateHtml(message = PH_APP_BOOT_MESSAGE, opts = {}) {
  return appBootOverlayInnerHtml(message, {
    withDots: opts.withDots,
    withProgress: opts.withProgress !== false,
    spinner: opts.spinner,
    captionId: opts.captionId,
  });
}

/** Preenche overlays estáticos do HTML com o padrão completo (idempotente). */
export function upgradeAppBootOverlays(root = document) {
  root.querySelectorAll(
    '.ph-app-boot-overlay:not(.hidden):not([hidden]):not(.ph-app-boot-overlay--error)',
  ).forEach((gate) => {
    if (!needsAppBootOverlayUpgrade(gate)) return;
    const label = gate.querySelector('.ph-app-boot-label, .ph-hub-boot-label');
    const msg = label?.textContent?.replace(/\s+/g, ' ').trim() || PH_APP_BOOT_MESSAGE;
    gate.innerHTML = appBootOverlayInnerHtml(msg, { withDots: false, withProgress: true });
  });
}
